import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const DefaultPage = WithErrorBoundary(
  'Simulador Financiero',
  'Error en Simulador Financiero',
  React.lazy(() => import('./DefaultPage')),
)
const TodasLasLineas = WithErrorBoundary(
  'Simulador Financiero',
  'Error en Simulador Financiero',
  React.lazy(() => import('./TodasLasLineas')),
)
const AltaDeLinea = WithErrorBoundary(
  'Simulador Financiero',
  'Error en Simulador Financiero',
  React.lazy(() => import('./AltaDeLinea')),
)
const ComparadorDeLineas = WithErrorBoundary(
  'Simulador Financiero',
  'Error en Simulador Financiero',
  React.lazy(() => import('./ComparadorDeLineas')),
)
const EdiciionLinea = WithErrorBoundary(
  'Simulador Financiero',
  'Error en Simulador Financiero',
  React.lazy(() => import('./EdiciionLinea')),
)
const SimuladorFinanciacion = WithErrorBoundary(
  'Simulador Financiero',
  'Error en Simulador Financiero',
  React.lazy(() => import('./SimuladorFinanciacion')),
)

export default {
  path: 'simulador-financiero',
  name: 'Simulador financiero',
  childRoutes: [
    { path: '', name: 'Todas las lineas', component: TodasLasLineas, isIndex: true },
    { path: 'todas-las-lineas', name: 'Todas las lineas', component: TodasLasLineas },
    { path: 'default-page', name: 'Default page', component: DefaultPage },
    { path: 'alta-de-linea', name: 'Alta de linea', component: AltaDeLinea },
    { path: 'comparador-de-lineas', name: 'Comparador de lineas', component: ComparadorDeLineas },
    { path: 'editar/:id', name: 'Ediciion linea', component: EdiciionLinea },
    { path: 'simulador-financiacion', name: 'Simulador financiacion', component: SimuladorFinanciacion },
  ],
}
